var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _polygon, _polygon2, _polygon3, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _polygon4, _path55, _path56, _path57, _path58, _polygon5, _path59, _path60, _path61, _path62, _path63, _polygon6, _path64, _path65, _path66, _path67, _path68, _ellipse, _path69, _path70, _path71, _path72, _ellipse2, _ellipse3, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEinsteinHeaderIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "71px",
    height: "78.9px",
    viewBox: "0 0 71 78.9",
    enableBackground: "new 0 0 71 78.9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FDD5A6",
    d: "M18.6,72c1.4-0.6,2.6-2.3,3.4-5.4c0.2-0.5,0.3-1.1,0.4-1.6c0.1-1-1.5-2.5-2.1-3.5c-2.2-3-3.9-1.5-4.3-1.8 c-0.7-0.6-1.4-1.3-2.8-2.5c-0.9-0.8-3-2.3-3.2-0.7s2.8,3.9,2.4,4.5l-0.1,0.1c-0.4,0-1.1,0-1.3,0.5l-0.2,1c-0.1,0.3,0,0.7,0.2,0.9 c0.1,0.1,0.1,0.3,0,0.4l0,0c-0.3,0.1-0.4,0.4-0.4,0.8v1.1c0,0.3,0.2,0.7,0.5,0.8c0.2,0.1,0.3,0.4,0.2,0.6s-0.1,0.4-0.1,0.6 c0,0.4,0.1,0.8,0.3,1.1c1.1,1.4,2.7,2.5,4.4,3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBF88",
    d: "M16,59.7c-0.7-0.6-1.4-1.3-2.8-2.5c-0.9-0.8-3-2.3-3.2-0.7s2.8,3.9,2.4,4.5l-0.1,0.1h1.2c0-0.1,0-0.2,0-0.3 C14.3,60.3,15.1,59.9,16,59.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBF88",
    d: "M21.2,72c0.2-0.9,0.2-1.8,0-2.6c0,0-2.5-0.6-2.8-2.8c-0.5-4.3-1.3-3.3-1.9-3.4c0.4,1.1,0.5,2.4,0.2,3.6 c-0.1,0.9-0.5,1.7-1.2,2.2c-0.9,0.6-2.4,0.4-3.7,0.3c0.4,0.8,2.2,1.9,3.9,2.7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#815A37",
    d: "M24.2,72l2-4.6c0,0,3.5-4.9,2.2-4.2C26,65.3,22.3,64,22.3,64s0.8,5.3-6.9,8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCAD84",
    d: "M13.7,61c-0.3-0.6,0.1,1.5,1.3,2.1c0.7,0.3,1.6,0.3,2.3,0.1C15.8,63.1,14.4,62.3,13.7,61z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#163860",
    d: "M42.2,72.8c0.3-5.9,0.4-12.1,0.4-12.1l-12.4,2c-2,2.9-3.6,6-4.8,9.3c0,0,6,0,11.2,0.1L42.2,72.8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M25.1,72l3.2-6.9l1.6-2.3l0.3,0.7c-1.4,2.8-2.7,5.5-3.7,8.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M38.4,65.3L38.4,65.3L38.4,65.3L38.4,65.3L38.4,65.3L38.4,65.3L38.4,65.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M38.2,65.5L38.2,65.5L38.2,65.5L38.2,65.5L38.2,65.5L38.2,65.5L38.2,65.5z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M37.8,65.8L37.8,65.8L37.8,65.8L37.8,65.8L37.8,65.8L37.8,65.8L37.8,65.8z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M34.4,69.1L34.4,69.1L34.4,69.1L34.4,69.1L34.4,69.1L34.4,69.1L34.4,69.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M35.4,68.1L35.4,68.1L35.4,68.1L35.4,68.1L35.4,68.1L35.4,68.1L35.4,68.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M34.7,68.8L34.7,68.8L34.6,69l0,0l0,0L34.7,68.8L34.7,68.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M35.2,68.3L35,68.5l0,0l0,0L35.2,68.3L35.2,68.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M34.9,68.6L34.9,68.6L34.9,68.6L34.9,68.6L34.9,68.6L34.9,68.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M34.2,69.4L34.2,69.4L34.2,69.4L34.2,69.4L34.2,69.4L34.2,69.4L34.2,69.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M33.7,69.9L33.7,69.9L33.6,70l0,0l0,0L33.7,69.9L33.7,69.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M33.5,70.1L33.5,70.1L33.5,70.1L33.5,70.1L33.5,70.1L33.5,70.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M34,69.6L34,69.6L34,69.6L34,69.6L34,69.6L34,69.6L34,69.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M36.5,67L36.5,67L36.5,67L36.5,67L36.5,67L36.5,67L36.5,67z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M36.9,66.6L36.9,66.6L36.9,66.6L36.9,66.6L36.9,66.6L36.9,66.6L36.9,66.6z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M37.3,66.2L37.3,66.2L37.3,66.2L37.3,66.2L37.3,66.2L37.3,66.2L37.3,66.2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M37,66.5L37,66.5L37,66.5L37,66.5L37,66.5L37,66.5L37,66.5z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M37.7,65.9L37.5,66l0,0l0,0L37.7,65.9L37.7,65.9L37.7,65.9z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M36.4,67.1L36.4,67.1L36.4,67.1L36.4,67.1L36.4,67.1L36.4,67.1L36.4,67.1z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M36.1,67.3L36.1,67.3L36,67.5l0,0l0,0L36.1,67.3L36.1,67.3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M35.9,67.6L35.9,67.6L35.9,67.6L35.9,67.6L35.9,67.6L35.9,67.6z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M35.7,67.8L35.5,68l0,0l0,0L35.7,67.8L35.7,67.8L35.7,67.8z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M33.2,70.4L33.2,70.4L33.2,70.4L33.2,70.4L33.2,70.4L33.2,70.4L33.2,70.4L33.2,70.4L33.2,70.4L33.2,70.4 L33.2,70.4L33.2,70.4L33.2,70.4L33.2,70.4L33.2,70.4z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#0C233B",
    points: "33.2,70.2 33.2,70 33.2,70 33.2,70 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#0C233B",
    points: "33.2,69.8 33.2,69.7 33.2,69.6 33.2,69.7 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#0C233B",
    points: "33.2,69.5 33.2,69.4 33.2,69.4 33.2,69.4 "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M30.3,63.8L30.3,63.8L30.3,63.8L30.3,63.8L30.3,63.8L30.3,63.8L30.3,63.8z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M30.4,64.4L30.4,64.4L30.4,64.4v0.2l0,0l0,0V64.4z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M30.4,64.1L30.4,64.1L30.4,64.1v0.2l0,0l0,0V64.1z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M30.7,65.8L30.7,65.8V66l0,0l0,0V65.8z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M30.5,64.8L30.5,64.8L30.5,64.8L30.5,64.8V65l0,0l0,0V64.8z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M30.6,65.4L30.6,65.4v0.2l0,0l0,0V65.4z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M30.6,65.1L30.6,65.1L30.6,65.1L30.6,65.1v0.2l0,0l0,0V65.1z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M30.8,66.1L30.8,66.1v0.2l0,0l0,0V66.1L30.8,66.1z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M30.9,66.4L30.9,66.4v0.2l0,0l0,0V66.4L30.9,66.4z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M31.8,68.7L31.8,68.7l0.1,0.2l0,0l0,0L31.8,68.7z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M32.2,69.3L32.2,69.3l0.1,0.2l0,0l0,0L32.2,69.3z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M31.7,68.4L31.7,68.4l0.1,0.2l0,0l0,0L31.7,68.4z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M32.9,70.2L32.9,70.2L32.9,70.2L32.9,70.2L32.9,70.2L32.9,70.2L32.9,70.2z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M32.6,69.9L32.6,69.9L32.6,69.9L32.6,69.9L32.6,69.9L32.6,69.9z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M32.4,69.6L32.4,69.6L32.4,69.6L32.4,69.6L32.4,69.6L32.4,69.6L32.4,69.6z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M32,69L32,69L32,69l0.1,0.2l0,0l0,0L32,69z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M31.3,67.4L31.3,67.4l0.1,0.2l0,0l0,0L31.3,67.4z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M31.1,67.1L31.1,67.1l0.1,0.2l0,0l0,0L31.1,67.1z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M31,66.8L31,66.8l0.1,0.2l0,0l0,0L31,66.8z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M31.4,67.8L31.4,67.8l0.1,0.2l0,0l0,0L31.4,67.8z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M31.5,68.1L31.5,68.1l0.1,0.2l0,0l0,0L31.5,68.1z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M33.1,70.4L33.1,70.4L33.1,70.4z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#DADAD9",
    d: "M38,63.9l-4.3,4.7l-1.7-2c0,0-0.7-3.5,0-5.2l0.4-0.8l5.9,0.7L38,63.9z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M41.4,58.2h1.8L43,59.9l-4.4,7.7l-2.9-5.5L35,61.6l-4.4,5c-0.5-1.6-0.7-3.2-0.6-4.8c0.1-1,0-1.8,0.7-2.2 C30.8,59.6,37.1,63.8,41.4,58.2z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#159AD6",
    d: "M34.5,62.3l-2.6,3.9c0.1,1.1,0.5,2.2,1.2,3.1c0,0,2-2.2,2.8-3.1v-3.9L34.5,62.3z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#1580AF",
    d: "M34.2,62.8c0.5,0.4,1.1,0.5,1.7,0.2v-0.5l-1.4-0.1L34.2,62.8z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#815A37",
    d: "M24.2,72c1.2-3.5,3.6-8.8,6-11.2l0.6,0.9C28.9,65,27.3,68.4,26,72H24.2z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#C1C0BD",
    points: "35.9,62.4 36.1,66 35.9,66.2 "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#815A37",
    d: "M43.1,57.9c0,0,7-2,7.3-1.8c0.3,5.7,1.3,11.3,3,16.7H41.9C42.4,65.9,43.1,57.9,43.1,57.9z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#472A16",
    d: "M43.1,59.5l1.5-0.2c0.1,2.3,0.9,4.5,2.2,6.4c0,0-3.6,1.4-4.4,2.7l3.4-0.4c-0.5,1.6-1,3.1-1.7,4.6H42 L43.1,59.5z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#693521",
    d: "M42.4,59.4l1.3-1c0,2.3,0.7,4.6,1.8,6.6c0,0-2.7,1.8-3.1,3.4l3.8-0.6c-1,1.6-1.8,3.3-2.6,5h-1.9L42.4,59.4z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1C0BD",
    d: "M31.8,65.5c0.5-0.5,1.7-2.3,1.7-2.3l-1.8,2C31.8,65.4,31.8,65.5,31.8,65.5z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#0C233B",
    points: "42.3,61.5 38.6,67.6 42.2,61.3 "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#1580AF",
    d: "M31.9,66.2L32,66c0.1,1.1,0.5,2.3,1.1,3.3C33.1,69.2,32.2,68.6,31.9,66.2z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C233B",
    d: "M31.8,65.5c-0.3,0.3-0.9,0.8-1.2,1.1l1.2-1.4V65.5z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#159AD6",
    d: "M36.8,61.7c0,0.6-0.7,1-1.6,1s-1.6-0.5-1.6-1c0-0.9,0.7-1,1.6-1S36.8,60.8,36.8,61.7z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#5B4026",
    d: "M46.7,77.1c-1,0.2-2-1.9-2-1.9l2.7-1.2C47.5,74,47.7,76.9,46.7,77.1z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCD7A9",
    d: "M41.8,68.4c-3.9,0.3-10,1.6-10.3,4.3l0,0c-0.2,2.7,14.8,2,14.8,2c0.2-0.6,0.4-1.3,0.5-2 C46.9,70.8,46.3,68.1,41.8,68.4z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#DBAC83",
    points: "31.5,72.7 31.5,72.8 31.5,72.8 "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBAC83",
    d: "M42.3,68.4c0,0,2.8,0.3,3.5,1.7c0.5,0.8,0.7,1.7,0.5,2.6c-0.6,1.7-3.3,2-5.1,2c-3.3,0-8.3-1.1-9.7-2l0,0 c-0.2,1.5,5.2,3.6,9.5,3.9c2.8,0.2,3-1.8,6.8-1.2c0.3-0.9,0.4-1.8,0.4-2.7C48.1,70.6,47.1,67.9,42.3,68.4z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#815A37",
    d: "M47.2,72.8c0.2,1.5,0,3-0.7,4.3c3.8,0.6,10.5-2.4,11.9-4.3c0.1-0.1,0.2-0.3,0.2-0.4c0.6-2-0.8-6.2-2.7-10.1 c-1.3-2.5-3.2-4.7-5.6-6.2l-1.7,10.6c-5,0.6-6.2,1.7-6.2,1.7C45.7,68.2,47,70.5,47.2,72.8z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#5B4026",
    d: "M49.8,61.7c0,0-0.8,3.8-0.9,5c0,0-2.2-0.4-6.5,1.7c1.8-1.3,3.9-2.1,6.1-2.3C48.8,64.6,49.3,63.1,49.8,61.7z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDD5A6",
    d: "M41.4,56.2l0.2,2.4c-1.5,2.3-4,3.5-6.7,3.4c-1.8-0.1-4.2-0.8-4.4-1.8c-0.2-0.8-0.2-1.6,0-2.4L41.4,56.2z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#CDAD87",
    d: "M40.7,59.7c-3.5,1-7.2,0.9-10.7-0.1l0.1-1.5l10.8-1.6L40.7,59.7z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#5B4026",
    cx: 39.7,
    cy: 57,
    rx: 10.5,
    ry: 3.9
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F7F7",
    d: "M22.2,52.1c-2.1-3.3-7.2,1-8.6,2.2s0.5-3.4,2.3-4c0,0-4.1-0.2-4.7,2.7c-0.3-1.9,0.4-3.8,1.9-5.1 c0,0-4.1,3.4-5,4.8c0.1-0.9,0.4-2,0.4-2l-3.1,0.5c0,0-0.8-7.9,4.6-9.4s-0.4-0.7-0.4-0.7S8,38.2,3.2,39.4c0,0,2.1-16.4,12-17.6 c0,0-0.9-3.5-4.4-2.8c0,0,0.5-1.8,2-1.8L10,15.8c0,0,8.5-4.9,15.4,2.6c0,0,2.4-11,2.4-12.4s0.1-3-0.4-3.8c0,0,3.3,0.6,3.3,2.1 c0.3-0.7,0.1-1.5-0.5-2c0,0,5.6,2.3,5.1,5L35.7,5c0,0,1.7,0.9,1.8,1.9s0.4-2.4,0.4-2.4s5.7,2.2,6,10.5c0,0,14.7-5.5,19.6,9.4 l-3.7-0.7c0,0,2.9,1.2,3.3,3.1c0,0,4.5,1.2,4.5,12.4c0,0-1.1-4.6-4.5-5.2c0,0,5,2.1,5.3,12.6c-1-0.9-2.2-1.6-3.5-2.1 c0,0,3.7,2.3,2.3,8.2c0,0-0.6-1.5-3.5-1.8l0.4,1.1l-2.2-1.1c0,0-7.1,0.6-8.9,2.7c0,0-0.3-2.8-2.5-1.4L22.2,52.1z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCD4A9",
    d: "M55,47.2c-0.5,6.2-4.6,12.6-13.1,12.3c-1.8,0-3.5,0.4-5.4,0.3c-7.5-0.6-14.8,0.4-15.7-10.3 c0-0.2-0.1-0.3-0.2-0.5c-0.5-1.4-0.7-3-0.6-4.5c0.6-7.7,9.3-13.5,19-12.7c1.7,0.1,3.4,0.5,5.1,1C51,35.1,55.5,40.9,55,47.2z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBC18D",
    d: "M31.4,32.5c2.5-0.7,5-1,7.6-0.8c1.7,0.1,3.4,0.5,5.1,1c7,2.4,11.5,8.2,11,14.4c-0.2,2.8-2.2,12-12.4,12.4 c0,0,13.8-9.3,2-19.5C40.7,36.7,36.2,34.2,31.4,32.5z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E6",
    d: "M29.4,45.9c0,0,0.4-2.9-1.6-2.6c0.5,0.2,0.7,0.8,0.5,1.3c0,0-1.1-3.3-5.4,0c0,0,1.4-0.5,1.9-0.2 c0,0-1.9,0.2-2,1.2c0,0,0.8-0.2,1.1,0.1c0,0-1.2,1,0.5,2.3C24.4,47.9,27.2,45.4,29.4,45.9z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.619537e-02 -0.9971 0.9971 7.619537e-02 -24.1533 73.7067)",
    fill: "#232221",
    cx: 27.7,
    cy: 49.9,
    rx: 2.1,
    ry: 1.4
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.619537e-02 -0.9971 0.9971 7.619537e-02 -11.1929 87.3978)",
    fill: "#232221",
    cx: 41.6,
    cy: 49.7,
    rx: 2.1,
    ry: 1.4
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E6",
    d: "M41.2,46.8c0,0,3.2,0,4.7,1.6c0,0,2.2-1-0.2-2.2c0.4-0.1,0.8-0.1,1.2,0.1c0,0,0-1.5-2.4-1.4 c0.5-0.3,1.1-0.3,1.6-0.1c0,0-2.2-2.3-3.7-0.2c0.1-0.5,0.5-1,1-1.2c-0.8,0-3.4-0.2-3.1,3.2L41.2,46.8z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#744E31",
    d: "M47.2,72.8c0.2,1.5,0,3-0.7,4.3c3.8,0.6,10.5-2.4,11.9-4.3c0.1-0.1,0.2-0.3,0.2-0.4c-2,0.6-4,1.1-6.1,1.3 C50.7,73.6,49,73.3,47.2,72.8z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#693521",
    d: "M24.8,72c1.6-3.4,3.5-6.7,5.6-9.8c0.4-0.4,0.4-1,0-1.4c0,0-4.6,3.5-4.7,3.6l-0.1,1.5l-1.1,0.9 c0,0-0.6,2.7-1,5.2"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E6",
    d: "M31.9,53.9c-2-1.6-8.2-2.8-7.5,7.2c0,0,0.4-1.6,1.4-1.5c0,0-0.4,2.5,0.9,3c0,0,0.6-2.5,1.6-1.9 c0,0,1.8,3,3.5,3.2c0,0-0.4-2.1,0.7-2.2l1.7,2.5l1.6-2.8c0,0,1.1,1.3,0.4,1.8c1,0,1.8-0.7,1.9-1.6c0,0,1.9,0.7,1.5,2.3 c0.9-0.6,1.4-1.6,1.4-2.7l1.6,2l0.4-3.3c0,0,2.6,1,2.6,2.1c0.4-1.7-0.2-3.6-1.5-4.8l2.6,0.5c0,0-5.7-6.6-10.4-3.1 C35.5,55.2,34.6,56,31.9,53.9z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#DADBD9",
    d: "M38.8,57c0,0,6.5,0.1,6.8,4.9C45.5,61.9,43.1,57.5,38.8,57z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#DADBD9",
    d: "M31.8,63.9c0,0-0.1-4.7,1.8-5.9C33.6,58,29.7,59.3,31.8,63.9z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#DADBD9",
    d: "M39.5,64c0,0,1.1-3.2-0.7-4.3C38.8,59.7,42.1,60.6,39.5,64z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#DADBD9",
    d: "M34.2,64.2c0,0,1.6-3.5,1.3-5.1c0.3,0.3,0.4,0.7,0.5,1.1C36.1,61.1,35.9,62.5,34.2,64.2z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#DADBD9",
    d: "M35,57.6c0,0,1.6,3.2,0.6,4l0.1,0.5c0.4,0.1,0.6,0.4,0.7,0.8C36.4,63,37.5,60.3,35,57.6z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#DADBD9",
    d: "M31.8,63.8c0,0-2.8-4.3-0.5-6.2c0,0-4,3.3,0.6,6.4"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#DADBD9",
    d: "M26.7,62.6c0,0,1-3.4,2.6-3.5C29.3,59.1,25.6,58.2,26.7,62.6z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#DADBD9",
    d: "M24.5,61.1c0.5-1.1,1.6-1.8,2.8-1.7l0.8-0.4C28,59.1,24.9,57.8,24.5,61.1z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#DADBD9",
    d: "M33.3,56.2c0,0-6.4-6-8.3,1.5c0,0,1.4-2.9,3.3-2.6c0,0-1,0.4-1,1.3C27.4,56.4,29.2,54.4,33.3,56.2z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#DADBD9",
    d: "M35.7,55.8c0,0,4.7-3,8.2,0.4C43.8,56.2,41.3,54.5,35.7,55.8z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F7F7",
    d: "M22.1,52.1c0,0-0.2-10.2,2.3-10.2c0,0,1.1,1.8,1.9,1.9c0.2,0,0-5.2,2.9-6.4c0,0,9.2,5.1,10.6,3 c-0.3-0.2-3.6-2-3.2-3.5c0.2-0.8,7.4,0,9.8,7.7c0.5,0.4,1.7-1.1,2.2-3.1c0.8-3.7,2.1,6.9,2.1,7.1s1-0.2,1.8-1.1s-0.4,5.7-0.7,6.4 c1.8-1.2,3.1-1.2,3.8-6.4c0.6-4.7-2.9-11-6.8-13.6c-3.2-2.1-10.5-3.8-19.6-1.1C18.3,36,19.7,45.5,19.8,47C20,49.6,22,51.3,22.1,52.1 z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E6",
    d: "M22.1,50.4c0,0-2.4-2.6-6.5,0.7c0,0,5.8-1.1,6.5,1V50.4z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E6",
    d: "M11.6,47.1c4.3-2.6,6.6-1.2,6.6-1.2c-4.6-0.2-5.3,3.5-5.3,3.5c2.7-1.9,6.2-2.5,9.3-1.4l0.1-1.4l0,0l0.2-1.4 C15.6,41.8,11.6,47.1,11.6,47.1z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E6",
    d: "M9.7,39.2c0,0,8.9-4.5,14.6,2.7C20.1,39,14.8,38,9.7,39.2z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E6",
    d: "M45.8,17.1c0,0,12.3-3.4,17.6,7.1C63.4,24.2,57,15.5,45.8,17.1z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E6",
    d: "M67.5,39.2c0,0-0.3-10.4-5.2-11c-0.2-1.8-1.1-3.5-2.5-4.6c0,0,2.7,1.1,3.1,3C63,26.6,68.3,27.9,67.5,39.2z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E6",
    d: "M44.2,17.9c0,0-2.3-10.6-6.3-13.5c0,0,6,2.2,6,10.5L44.2,17.9z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E6",
    d: "M13.1,15.6c0,0,10.8-3.3,16.6,11.4C26.1,20.9,20,16.7,13.1,15.6z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E6",
    d: "M13.1,18.4c0,0,3.8-0.5,5.1,4.4C18.1,22.8,18.8,16.1,13.1,18.4z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E6",
    d: "M3.1,39.2c0,0,4.7-14.5,12-17.4C15.1,21.8,5.7,21.9,3.1,39.2z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E6",
    d: "M28.6,37.3c-3.2-1.2-10.9-5.1-9.3-10c0,0-3.5,5.1,3.5,8c0,0-4.1-1.1-5.7,0.1c0,0,6.7,1,10.7,3.2 c0.4-0.5,0.9-1,1.5-1.2C29.2,37.4,28.7,37.4,28.6,37.3z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E6",
    d: "M39.8,40.4c0,0-12.6-6.7-4.5-7.4C35.3,33,20.9,31.1,39.8,40.4z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E6",
    d: "M39.8,40.4c0,0-0.7,2.3-9.2-2.2C30.6,38.2,37.2,40.8,39.8,40.4z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E6",
    d: "M27.3,2c0,0,1.3,2.5-2,16.3C25.3,18.3,33.2,6.2,27.3,2z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E6",
    d: "M41.8,27.4c0,0,4.7-4.6,8.7-2.9c-2.1-1.8-5-2.3-7.6-1.1c0.9-0.7,1.9-1.2,2.9-1.6c0,0-2.7-0.1-3.6,0.6 c0,0-1.7-4.7-11-2.5C31.2,19.8,41.2,19,41.8,27.4z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E6",
    d: "M56.7,34.6c0.9-1.4,1.5-2.9,1.7-4.6c0.8-5-4.8-3.5-4.8-3.5s4.3-0.4,3.8,3.2s-6.7,7-6.7,7 c0.5-2.2,0.5-4.7-1.7-5.9c0,0,1.6,4-1.1,10.8c-0.6-12-8-11.4-8-11.4c6.2,1.5,7.2,11.9,7.2,13.1c-0.2,0.4-0.4,0.9-0.7,1.3 c0,0,1,1.2,2.5-3.7l0.7,1.8c4.5-9.8,14.8-6.1,14.8-6.1C62.9,33.6,58.2,34.2,56.7,34.6z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E6",
    d: "M40.5,18.3c-2.2-2.1-4.6-4.7-5-6.7c-0.2-1.2-0.2-2.4-0.1-3.6c0.3-3-1.3-4.7-5.4-5.9c0,0,3.4,1.7,3.5,8.5 c-0.7-0.7-1.5-1.3-2.4-1.8c2.2,1.6,1.5,3.5,2.3,4.7S40.5,18.3,40.5,18.3z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBECEC",
    d: "M66.1,37c0.7,0.2,2.1,4.9,2.2,9.4c-1-0.9-2.2-1.6-3.5-2.1c0,0,3.7,2.3,2.3,8.2c0,0-0.6-1.5-3.5-1.8l0.4,1.1 l-2.2-1.1c0,0-8.3,1.3-10.2,3.5c0,0,1.2-6.9,0.8-6.5c-1.2,1.2-1.7,1-1.7,1s-0.2-1.7-1-6C49.5,41.1,54.6,33,66.1,37z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E6",
    d: "M58.5,49.7c1.9-0.8,4.1-0.4,5.5,1c0.2,0.2,0.1,1.2,0.1,1.2l-2.2-1.1c0,0-8.1,2-10.3,3.5 C53.4,52.2,55.8,50.6,58.5,49.7z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E6",
    d: "M55.9,47.1c2.2-0.1,4-1.6,4.5-3.7c0.4-1.2,0.6-2.5,0.7-3.8c0,0,1.2,5.3,0.2,6.3c3.3,0.5,5.8,3.3,5.9,6.7 c0,0-3.3-5-11.4-4.3c-1.1,0.2-2.2,0.4-3.2,0.8v-1.3L55.9,47.1z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E6",
    d: "M68.3,46.5c0,0-2-6.9-4.7-6.8C63.6,39.7,67.6,38,68.3,46.5z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#45413E",
    d: "M57.8,66.9c-1.3,1.7-2.2,3.7-2.7,5.8c-0.1,0.7,0,1.6,0.1,2.4c1.3-0.5,2.6-1.5,3.3-2.4l0,0 c0.1-0.1,0.1-0.3,0.2-0.4C59.3,70.6,57.8,66.9,57.8,66.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEinsteinHeaderIcon);
export default __webpack_public_path__ + "static/media/einstein-header-icon.2c39b48ceb128b9387e81d0773538568.svg";
export { ForwardRef as ReactComponent };